export default "assets/images/icons/eye-aec8b7a1.svg";